<template>
  <div class="user-appen">
    <div class="user-appen-img" v-if="info.value">
      <img :src="getImage" alt="" >
    </div>
    <div class="user-appen-info" v-if="info.value">
      <div class="info-name">{{ info.value.realname }}</div>
      <div class="info-org">{{  getOrgName  }}</div>
    </div>
  </div>
</template>

<script>
import { getOrgShowName } from "@/api/global.js";
import { getKey } from "../utils";
export default {
  // 组件名称
  name: 'userAppen',
  // 组件参数 接收来自父组件的数据
  props: {
    config: {
      type: Object,
      default: ()=> {}
    },
    info: {
      type: Object,
      default: ()=> {}
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
      return {}
  },
  // 计算属性
  computed: {
    getImage() {
      let url = ''
      const info = this.info.value
      const user = localStorage.getItem('user')
      let token = ''
      if (user) {
        token = JSON.parse(user).accesstoken
      }
      if (info.facephotos) {
        url = info.facephotos[0].faceUrl.replace('userfiles', 'confiles') + `?accesstoken=${token}`
        return this.$imgurl + url
      } else {
        let avatar = info.avatar
        if (avatar) {
          if (avatar.includes('img-')) {
            url = this.$imgurl + avatar
          } else {
            const list = avatar.split('/')
            const num = list[list.length - 1]
            let format = `${num}.jpg`
            if (Number(num)>=36) {
              format = `${num}.svg`
            }
            url = `https://bigdata.topeti.com/PCRepository/middleground/avatar/${format}`
          }
        } else {
          if (info.sex && info.sex === '女') {
            url = 'https://bigdata.topeti.com/PCRepository/middleground/avatar/16.jpg'
          } else {
            url = 'https://bigdata.topeti.com/PCRepository/middleground/avatar/23.jpg'
          }
        }
        return url
      }
    },
    getOrgName() {
      const info = this.info.value
      let obj = {}
      const looktype = this.info.looktype || 0
      if (info['部门：班级']) {
        const isStr = typeof info['部门：班级'] === 'string'
        obj = isStr ? { name: info['部门：班级'], looktype } : info['部门：班级'][0]
      } else {
        const name = getKey(info.orgname) && getKey(info.orgname).split(',')[0]
        obj = { name, looktype }
      }
      return getOrgShowName(obj, { isNeedType: false })
    },
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
  },
}
</script>

<style scoped lang="scss">
.user-appen {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &-img {
    width: 37px;
    height: 37px;
    border-radius: 100%;
    flex-shrink: 0;
    overflow: hidden;
    background-color: rgb(214, 227, 255);
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &-info {
    overflow: hidden;
    flex: 1;
    margin-left: 10px;
    .info-name {
      color: #101010;
      font-weight: 400;
      font-size: 15px;
      margin-bottom: 3px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .info-org {
      color: #999999;
      font-weight: 400;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }


}
</style>
